export default "__VITE_ASSET__BjH79o4J__"